/**
 * The Home and Team Tasks cards' one urgency signal: a 3px rule on a row's left edge, in the
 * design system's status colours — overdue tasks and clients waiting 3+ days `danger`, clients
 * waiting a day `warning`, the next meeting `brand`. An inset shadow, so a row never shifts. Each
 * row also says it in words (the group, the age, the time); the colour is never the only sign.
 */
export const RAIL = {
  danger: 'shadow-[inset_3px_0_0_var(--color-danger)]',
  warning: 'shadow-[inset_3px_0_0_var(--color-state-warning-fg)]',
  brand: 'shadow-[inset_3px_0_0_var(--color-brand)]',
} as const;

/** The same rule on every `<li>` of a list. */
export const RAIL_ROWS = {
  danger: '[&>li]:shadow-[inset_3px_0_0_var(--color-danger)]',
} as const;

export type Urgency = keyof typeof RAIL;

/** A count beside a card or group title. */
export const countPill =
  'bg-muted text-muted-foreground rounded-full px-1.5 text-xs leading-5 font-medium tabular-nums';
